import Modal from './Modal';
import Button from './Button';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmDialog({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
  children
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      {children ? (
        <div className="mb-6">{children}</div>
      ) : (
        <div className="flex items-start gap-3 mb-6">
          <AlertTriangle className="w-6 h-6 text-warning flex-shrink-0 mt-1" />
          <p className="text-gray-700">{message}</p>
        </div>
      )}
      
      <div className="flex gap-3 justify-end">
        <Button variant="outline" onClick={onClose}>
          {cancelText}
        </Button>
        <Button variant={variant} onClick={onConfirm}>
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
}
